import { marked, Renderer as MarkedRenderer, Tokens } from 'marked';

const renderer = new MarkedRenderer();

// Override default renderer to be aligned with rich editor output:
renderer.paragraph = function ({ tokens }: Tokens.Paragraph) {
  const text = this.parser.parseInline(tokens);
  return `<div>${text}</div>\n`;
};

renderer.del = ({ text }: { text: string }) => {
  return `<strike>${text}</strike>`;
};

/**
 * Parses markdown string to an HTML.
 */
export function parseMarkdownToHtml(markdown: string): string {
  if (!markdown) return '';

  const options = {
    renderer: renderer,
    gfm: true,
    breaks: true,
    tables: true,
    xhtml: true,
    headerIds: false,
  };

  return marked.parse(markdown, options).toString();
}
